import React, { ComponentProps } from "react";

function HandHoldingDollarIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width={30}
      height={31}
      viewBox="0 0 30 31"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect y="0.951172" width={30} height={30} rx={8} fillOpacity="0.2" />
      <g clipPath="url(#clip0_68_79763)">
        <path d="M24.9928 18.4998C24.531 17.8731 23.6508 17.7378 23.0247 18.2019L18.8137 21.3044H14.5697C14.2619 21.3044 14.0068 21.0493 14.0068 20.7417C14.0068 20.4338 14.2619 20.1787 14.5697 20.1787H17.323C17.886 20.1787 18.405 19.796 18.4973 19.2421C18.6116 18.5383 18.0707 17.927 17.3846 17.927H11.755C10.805 17.927 9.88579 18.2524 9.14693 18.8506L7.51079 20.1787H5.56244C5.25462 20.1787 4.99951 20.4338 4.99951 20.7417V24.1188C4.99951 24.4267 5.25462 24.6818 5.56244 24.6818H17.7717C18.5468 24.6818 19.3171 24.4289 19.9427 23.9685L24.6948 20.4668C25.3205 20.006 25.454 19.1255 24.9928 18.4998Z" />
        <path
          opacity="0.5"
          d="M14.8313 12.8254C14.5608 12.7848 14.21 12.6583 13.901 12.5467L13.7295 12.4851C13.2885 12.3301 12.8069 12.5599 12.6507 12.9992C12.4946 13.4384 12.7255 13.9212 13.1643 14.0773L13.3281 14.1356C13.6267 14.2433 13.9579 14.3502 14.2925 14.4282V14.8295C14.2925 15.2957 14.6707 15.674 15.137 15.674C15.6032 15.674 15.9815 15.2957 15.9815 14.8295V14.4626C16.8705 14.2613 17.4904 13.6937 17.6353 12.854C17.9409 11.093 16.2662 10.6141 15.3679 10.3574L15.1502 10.2941C14.2562 10.0314 14.276 9.91809 14.3013 9.77347C14.3419 9.53543 14.8401 9.41942 15.4349 9.51344C15.6087 9.54092 15.8352 9.60306 16.1266 9.70422C16.5675 9.85486 17.0491 9.62284 17.2009 9.1819C17.3527 8.74097 17.1195 8.26042 16.6786 8.1076C16.4111 8.01517 16.1891 7.95433 15.9815 7.90637V7.51051C15.9815 7.04428 15.6032 6.66602 15.137 6.66602C14.6707 6.66602 14.2925 7.04428 14.2925 7.51051V7.88054C13.4036 8.08167 12.7809 8.64544 12.6365 9.48539C12.3341 11.2266 14.033 11.7264 14.674 11.915L14.9027 11.9809C16.0166 12.2998 15.9991 12.3994 15.9704 12.5665C15.9298 12.8045 15.4338 12.9205 14.8313 12.8254Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_68_79763">
          <rect
            width="20.2679"
            height="18.0159"
            fill="white"
            transform="translate(4.99951 6.66602)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default HandHoldingDollarIcon;
